import Highchart from "highcharts";

export default {
  methods: {
    /// ESTADOS

    /**
     * Limpa os campos do autocomplete
     */
    limparAutocomplete() {
      this.estadoAutocomplete = {
        chave: "",
        descricao: ""
      };
    },
    /**
     * Método que é chamado na ação de limpar o autocomplete
     */
    limparEstado() {
      this.$emit("remove-filtro", {
        chaveRemocao: "estado",
        sucesso: () => this.ativarDadosEstado()
      });
    },

    ativarDadosEstado() {
      this.limparAutocomplete();
      this.ativarTooltip();
      this.esconderTooltip();
      this.removerLegendas();

      this.trocarVisibilidadeSerie(1, true);

      this.desmarcarEstado();

      this.adicionarLegendaRegiao();

      this.estadoMarcado = false;
    },

    /**
     * Método que é chamado na hora de selecionar algum item no autocomplete
     * @param { Number } index
     */
    selecionarEstado(index) {
      if ([-1, undefined].includes(index)) return;

      const chaveEstado = this.listaEstados[index].chave;
      this.estadoAutocomplete.chave = chaveEstado;

      this.$emit("adiciona-filtro", {
        chaveAdicao: "estado",
        chaveRemocao: this.regiaoClicada !== null ? "regiao" : undefined,
        value: chaveEstado,
        sucesso: () => this.desativarDadosEstado(chaveEstado)
      });
    },

    /**
     * Foca em um estado, remove as legendas de regiões e adiciona
     * as legendas do estado
     * @param { String } chaveEstado
     */
    desativarDadosEstado(chaveEstado) {
      if (this.regiaoClicada !== null) {
        const point = this.graficoRef.series[1].points.find(
          e => e.properties.sigla === this.regiaoClicada
        );

        this.ativarDadosRegiao(point, false);
      }

      this.adicionarValorEstado(chaveEstado);
      this.marcarEstado(chaveEstado);
      this.removerLegendas();
      this.adicionarLegendaEstado(chaveEstado);
    },
    adicionarValorEstado(chaveEstado) {
      let index = this.dataEstados.findIndex(e => e.sigla === chaveEstado);

      let value = this.totalPrestadoresEstado;
      let porcentagem = (value / this.totalPrestadoresBase) * 100;
      porcentagem = Highchart.numberFormat(porcentagem, 2);

      this.$set(this.dataEstados[index], "value", value);
      this.$set(this.dataEstados[index], "porcentagem", porcentagem);
      this.graficoRef.series[0].points
        .find(e => e.properties.sigla === chaveEstado)
        .update({
          value,
          porcentagem
        });
    },
    /**
     * Adiciona algum estado na legenda
     * @param { String } chaveEstado
     */
    adicionarLegendaEstado(chaveEstado) {
      const estadoAtual = this.dataEstados.find(e => e.sigla === chaveEstado);

      const serieEstado = {
        ...estadoAtual,
        color: this.cores[0],
        grouping: false,
        events: {
          legendItemClick: ev => this.cliqueLegendaEstado(ev)
        },
        data: [
          {
            sigla: estadoAtual.sigla,
            value: estadoAtual.value,
            name: estadoAtual.name
          }
        ],
        legendIndex: 0,
        id: estadoAtual.sigla
      };

      this.graficoRef.addSeries(serieEstado);
    },
    /**
     * Ação de clique na legenda de estado
     * @param { Event } ev
     */
    cliqueLegendaEstado(ev) {
      this.limparEstado();

      ev.preventDefault();
    },
    /**
     * Marca algum estado e deixa os outros inativos
     * @param { String } sigla
     */
    marcarEstado(sigla) {
      let pointsEstado = this.$refs.mapa.chart.series[0].points;
      this.trocarVisibilidadeSerie(1, false);

      pointsEstado.forEach(e => {
        if (e.properties.sigla === sigla) {
          e.setState("hover");

          this.graficoRef.tooltip.refresh(e);
          this.desativarTooltip();
        } else {
          e.setState("inactive");
        }
      });

      this.estadoMarcado = true;
    },
    /**
     * Troca o estado de cada estado para normal
     */
    desmarcarEstado() {
      let pointsEstado = this.graficoRef.series[0].points;
      pointsEstado.forEach(e => {
        e.setState("");
      });
    }
  }
};
